import { PDFJS_DOCUMENT_OPTIONS, initPdfJs } from "@/components/document-viewer/pdfjs-config.ts";
import type { PdfRuntime } from "@skailer-com/uikit";
import { TextLayer, getDocument } from "pdfjs-dist";

export const pdfRuntime: PdfRuntime = {
  getDocument,
  TextLayer,
  documentOptions: PDFJS_DOCUMENT_OPTIONS,
  ensureWorker: initPdfJs,
};
